import { inject, Provider } from '@angular/core';
import { CapabilityService, DocumentsSummary } from '@libs/shared/services';
import { DocumentService } from './document.service';

export const provideDocumentsSummary = (): Provider => ({
  provide: DocumentsSummary,
  useFactory: (): DocumentsSummary | null => (inject(CapabilityService).isAvailable('services.documents')() ? inject(DocumentService) : null),
});
